const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

require('./RiskDot.scss');

const RiskDot = ({ active, style, value }) => (
    <span
        className={classNames('risk-indicator__risk-dot', { active })}
        style={style}
    >
        {value}
    </span>
);

RiskDot.defaultProps = {
    active: false,
    style: {},
};

RiskDot.propTypes = {
    active: PropTypes.bool,
    style: PropTypes.object,
    value: PropTypes.number.isRequired,
};

module.exports = RiskDot;
